import getUrl from "../getUrl";


export default async function currentLanguage() {
  // Запрос на любой URL может отдать текущий язык
  const res = await fetch(getUrl('/api/v1/dictionaries/fw/contents/nav_about_fw'));
  return (res.headers.get('x-content-language') || 'ru').toLowerCase();
}



// WEBPACK FOOTER //
// ./src/text/currentLanguage.js